function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M632.415,572.665s53.336,24.82,71.027,25.876h34.589s34.061-21.123,48.584-17.955a39.951,39.951,0,0,0,17.691-2.64c9.769-3.7,18.482-11.09,18.482-11.09",
  transform: "translate(-623.811 -42.567)",
  fill: "none",
  stroke: "#54b0ff",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M706.434,43.79c-5.992.089-13.212,3.609-18.977,5.116-10.638,2.78-22.356,3.847-32.645,7.629-11.413,4.043-23.408,11.547-26.8,23.818-3.645,13.2-3.532,25.4-3.407,38.967l0.528,57.476,0.738,80.176,0.828,90.12,0.8,87.308,0.66,71.738,0.4,43.413c0.012,1.287-.08,2.625.036,3.907,0.408,4.506,3.036,8.267,3.281,12.87,0.123,2.3.044,4.633,0.054,6.937,0.031,7.089.023,14.178,0.012,21.268q-0.016,12.065-.061,24.128c-0.014,4.021-.065,8.043-0.046,12.064,0.024,5.067-1.262,8.577,2.947,12.4,4.262,3.872,9.345,6.369,14.013,9.657,4.162,2.93,8.445,5.724,12.766,8.415,16.376,10.2,31.745,14.749,50.932,16.151,8.965,0.655,19.262,1.956,27.568-2.361,6.026-3.131,10.645-10.249,15.208-15.264l33.8-37.144,27.557-30.287s4.225-3.521,6.337-16.2l0.614-25.855,1.589-66.926,2.188-92.14,2.409-101.495,2.255-94.992,1.725-72.629q0.356-15.023.774-30.042c0.267-9.384-4.046-18.471-10.214-25.353a42.4,42.4,0,0,0-10.609-8.62c-1.608-.91-5.079-1.59-6.289-2.816-1.462-1.481-.864-3.91-1.651-6-1.952-5.173-9.853-5.078-14.476-5.443C777.932,42.736,706.759,43.785,706.434,43.79Z",
  transform: "translate(-623.811 -42.567)",
  fill: "none",
  stroke: "#54b0ff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 42.467,
  y1: 294.963,
  x2: 42.762,
  y2: 544.643,
  fill: "none",
  stroke: "#54b0ff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M625.021,105.84s48.848-12.674,87.4,0c0,0,5.017,2.9,5.281,15.842s0,202.784,0,202.784-2.112,14.786-31.949,13.994c0,0-55.977-.65-58.089-20.788S625.021,105.84,625.021,105.84Z",
  transform: "translate(-623.811 -42.567)",
  fill: "none",
  stroke: "#54b0ff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M630.39,131.8s54.921-8.8,76.044,9.5V245.166S667,251.855,630.39,239.181V131.8Z",
  transform: "translate(-623.811 -42.567)",
  fill: "none",
  stroke: "#54b0ff",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 44.601,
  cy: 251.66,
  r: 18.251,
  fill: "none",
  stroke: "#54b0ff",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 141.536,
  y: 68.024,
  width: 49.331,
  height: 172.101,
  rx: 12,
  ry: 12,
  fill: "none",
  stroke: "#54b0ff",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
});

function SvgAccord1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 211.468,
    height: 636.236,
    viewBox: "0 0 211.468 636.236",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "accord_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccord1);
export default __webpack_public_path__ + "static/media/accord_1.33ed41aeeebe2c45b5232b135cf63441.svg";
export { ForwardRef as ReactComponent };